// extracted by mini-css-extract-plugin
export default {"iconTooltip":"IconTooltip_iconTooltip__3M4eL","sarlanga":"IconTooltip_sarlanga__DgMCo"};